import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";

import {
  FaBox,
  FaDesktop,
  FaChartLine,
  FaBullhorn,
  FaBuilding,
  FaFileAlt,
  FaFileInvoice,
  FaEllipsisH,
  FaTimes,
  FaUpload,
  FaCheck,
  FaInfoCircle,
  FaEdit,
  FaTrash,
} from "react-icons/fa";
import { Theme } from '../../lib/theme';
import { useNavigate } from "react-router-dom";
import { IpInfoResponse } from "../../types/authTypes";
import { Plan } from "../../types/pricingTypes";
import { PricingModal } from "../shared/PricingModal";
import { toast } from "react-toastify";
import { useSelector,useDispatch } from "react-redux";

import { setUserPlan } from "../../redux/slices/userSlice";
import uploadFileToS3 from "../../utils/uploadFileToS3";
import GuidedTour from "../onboarding/shared/GuidedTour";
import { useOutlineContext } from "../presentation-view/OutlineContext"; // Import Context API
import GuidedTourMobile from "../onboarding/shared/GuidedTourMobile";
import { Dialog } from "@headlessui/react";
import WebsiteLinkForm from "../onboarding/onboarding-sections/WebsiteLinkForm";
import { PricingModalNew } from "../shared/PricingModalNew";
import { getStaticPricing, getStaticPricingBundle } from "../../utils/pricingConfig";
import PaymentGateway from "../payment/PaymentGateway";
import { selectPptCount, selectPptLimit, setPptCount, setPptLimit,selectIsEligibleForDownload,setIsEligibleForDownload } from '../../redux/slices/pptSlice';
import {
  setPptSlideCount,
  setPptTargetLanguage,
  setPptPresentationTone,
  setPptTargetAudience,
  setPptIncludeImages,
  setTechnicalDepth,
  resetToAuto,
} from "../../redux/slices/presentationOptionsSlice";
// Define an interface for colors
interface Colors {
  P100: string;
  P75_S25: string;
  P50_S50: string;
  P25_S75: string;
  S100: string;
  F_P100: string;
  F_P75_S25: string;
  F_P50_S50: string;
  F_P25_S75: string;
  F_S100: string;
  SCL: string;
  SCD: string;
}
interface SlideOutline {
  slideName?: any;
  title: string;
  type: string;
  keywords?: string;
  method?: string;
  outlineID: string;
}
const outlineTest: SlideOutline[] = [
  {
    title: "Introduction to Labor Movements",
    type: "Points",
    keywords: "Industrial revolution, Workers’ unions",
    outlineID: "outlineID-1a2b3c4d-1111-aaaa-2222-333344445555",
  },
  {
    title: "Early Struggles and Resistance",
    type: "Points",
    keywords: "Protests, Wage disputes, Exploitation",
    outlineID: "outlineID-2b3c4d5e-2222-bbbb-3333-444455556666",
  },
  {
    title: "Rise of Trade Unions",
    type: "Points",
    keywords: "Collective bargaining, Unionization",
    outlineID: "outlineID-3c4d5e6f-3333-cccc-4444-555566667777",
  },
  {
    title: "Legal Milestones in Labor Rights",
    type: "Points",
    keywords: "Labor laws, Minimum wage, Child labor bans",
    outlineID: "outlineID-4d5e6f70-4444-dddd-5555-666677778888",
  },
  {
    title: "Modern Challenges in the Workforce",
    type: "Points",
    keywords: "Gig economy, Job insecurity, Automation",
    outlineID: "outlineID-5e6f7081-5555-eeee-6666-777788889999",
  },
  {
    title: "Global Perspectives on Labor Reforms",
    type: "Points",
    keywords: "ILO, International standards, Developing nations",
    outlineID: "outlineID-6f708192-6666-ffff-7777-888899990000",
  },
  {
    title: "Conclusion and Future Outlook",
    type: "Points",
    keywords: "Sustainable labor, Equity, Digital rights",
    outlineID: "outlineID-7f8192a3-7777-aaaa-8888-999900001111",
  },
];

const supportedLanguages = ["English", "Chinese (Simplified)", "Chinese (Traditional)", "Spanish", "French", "German", "Portuguese (Brazilian)", "Portuguese (European)", "Italian", "Russian", "Japanese", "Korean", "Dutch", "Arabic (Modern Standard)", "Polish", "Turkish", "Vietnamese"]

const SelectPresentationType: React.FC = () => {
  const presentationTypes = [
    { id: 1, label: "Product", icon: <FaBox style={{ color: Theme.colors.primary }} /> },
    {
      id: 2,
      label: "Pitch Deck",
      icon: <FaDesktop style={{ color: Theme.colors.primary }} />,
    },
    {
      id: 3,
      label: "Sales Deck",
      icon: <FaChartLine style={{ color: Theme.colors.primary }} />,
    },
    {
      id: 4,
      label: "Marketing",
      icon: <FaBullhorn style={{ color: Theme.colors.primary }} />,
    },
    {
      id: 5,
      label: "Company Overview",
      icon: <FaBuilding style={{ color: Theme.colors.primary }} />,
    },
    {
      id: 6,
      label: "Project Proposal",
      icon: <FaFileInvoice style={{ color: Theme.colors.primary }} />,
    },
    {
      id: 7,
      label: "Project Summary",
      icon: <FaFileAlt style={{ color: Theme.colors.primary }} />,
    },
    {
      id: 8,
      label: "Others",
      icon: <FaEllipsisH style={{ color: Theme.colors.primary }} />,
    },
  ];
  const [isRefineModalOpen, setIsRefineModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleColorChange = (
    key: keyof typeof brandingColors,
    color: string
  ): void => {
    setBrandingColors((prev) => ({ ...prev, [key]: color }));
  };
  const [file, setFile] = useState<File | null>(null);
  const userAgent = navigator.userAgent.toLowerCase();
  const { setIsOutlineGenerated } = useOutlineContext(); // ✅ Use Context API
  const [theme, setTheme] = useState("Light");
  const [creativity, setCreativity] = useState(5);
  const [pdfLink, setPdfLink] = useState("");
  const [pdfUploading, setPDFUploading] = useState(false);
  const [selectedType, setSelectedType] = useState<number | null>(null);
  const [customTypeInput, setCustomTypeInput] = useState<string>("");
  const navigate = useNavigate();
  const authToken = sessionStorage.getItem("authToken");
  const orgId = sessionStorage.getItem("orgId");
  const [isPricingModalOpen, setIsPricingModalOpen] = useState(false);
  const pricingModalHeading = "Refine PPT";
  const userPlan = useSelector((state: any) => state.user.userPlan);
  const [monthlyPlan, setMonthlyPlan] = useState<Plan>();
  const [yearlyPlan, setYearlyPlan] = useState<Plan>();
  const [currency, setCurrency] = useState("");
  const [subId, setSubId] = useState("");
  const dispatch = useDispatch();
  const [eligibleForGeneration, setEligibleForGeneration] = useState(false);
  const [showThemeTooltip, setShowThemeTooltip] = useState(false);
  const [hoveredTheme, setHoveredTheme] = useState<string | null>(null); // Track which theme is hovered
  const [pptCount, setPptCount] = useState(0);
  const [pptCountMonthly, setPptCountMonthly] = useState(0);
  const [showTooltip, setShowTooltip] = useState(false);
  const [showTooltip1, setShowTooltip1] = useState(false);
  const [showTooltip2, setShowTooltip2] = useState(false);
  const [showTooltip3, setShowTooltip3] = useState(false);
  const [showTooltip4, setShowTooltip4] = useState(false);
  const [showTooltip5, setShowTooltip5] = useState(false);
  const [websiteUrl, setWebsiteUrl] = useState<string>("");
  const [isHovered, setIsHovered] = useState(false);
  const [primaryColor, setPrimaryColor] = useState("#000000"); // Define the primary color
  const [textColor, setTextColor] = useState("#000000"); // Define the primary color
  const [secondaryColor, setSecondaryColor] = useState("#FFFFFF"); // Define the secondary color
  const [generateInput, setGenerateInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [outline, setOutline] = useState<SlideOutline[]>([]);
  const [generatedDocumentIDoutline, setGeneratedDocumentIDoutline] = useState<
    string | null
  >(null);
  const [brandingColors, setBrandingColors] = useState<string[]>([]); // Initialize branding colors
  const [brandingColorsSave, setBrandingColorsSave] = useState<string[]>([]); // Initialize branding colors
  const [isLoading, setIsLoading] = useState<boolean>(false); // Add a loading state
  const [isValidLink, setIsValidLink] = useState(false);
  const [organizationColors, setOrganizationColors] = useState<Colors | null>(
    null
  );
  const urlRegex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
  const [language,setLanguage]=useState<string>("English");
  const [inputIndex, setInputIndex] = useState<number | null>(null);
  const [newOutline, setNewOutline] = useState<string>("");
  const [newOutlineLoading, setNewOutlineLoading] = useState(false);
  const [activeTab, setActiveTab] = useState<"outline" | "options">("options");
  const [editingIndex, setEditingIndex] = useState<number | null>(null);
  const [editedOutline, setEditedOutline] = useState<{
    title: string;
    keywords: string;
    slideInput:string;
  }>({ title: "", keywords: "" ,slideInput:""});
  const [isOutlineReviewed, setIsOutlineReviewed] = useState<boolean>(false);
  const [isOutlineLoading, setIsOutlineLoading] = useState<boolean>(false);
  const generateOutlineID = () => {
    return `outlineID-${window.crypto.randomUUID()}`;
  };  
  const [isDiscounted, setIsDiscounted] = useState(false);
  const [isBundle, setIsBundle] = useState(false);
  const currentCurrency=sessionStorage.getItem('currency')
  const pricing = getStaticPricing(currentCurrency === "INR" ? "INR" : "USD"); // ✅ get dynamic prices
  const discountedAmount = pricing.original; // 49 or 1
  const currentAmount = pricing.current; // 99 or 2
  const bundlePricing = getStaticPricingBundle(
      currentCurrency === "INR" ? "INR" : "USD"
  );
  const bundleDiscountedAmount = bundlePricing.original;
  const bundleCurrentAmount = bundlePricing.current;
  const [pptLimit,setpptLimit]=useState(0);
  const [includeWebSearch, setIncludeWebSearch] = useState<boolean>(false);
  const presentationOptions = useSelector((state: any) => state.presentationOptions) || {};
  const {
    pptSlideCount,
    pptTargetLanguage,
    pptPresentationTone,
    pptTargetAudience,
    pptIncludeImages,
    technicalDepth,
  } = presentationOptions;
  
  
  const fetchOutlines = useCallback(async () => {
    if (!generatedDocumentIDoutline) return;

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/outline/${generatedDocumentIDoutline}/outline`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const { outline: fetchedOutlines } = response.data;

      setOutline(fetchedOutlines);
    } catch (error) {
      console.error("Error fetching outlines:", error);
    }
  }, [generatedDocumentIDoutline, authToken]);

  const handleAddOutline = async (index: number) => {
    const newOutlineID = generateOutlineID();

    setNewOutlineLoading(true);
    if (!newOutline.trim()) {
      console.log("New outline is empty");
      setNewOutlineLoading(false);
      return;
    }
    const updatedOutline = { title: newOutline };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/outline/blocklist/insert`,
        {
          documentId: generatedDocumentIDoutline,
          title: updatedOutline.title,
          position: index + 1,
          outlineID: newOutlineID,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const result = response.data;
      if (result.title && result.type) {
        // Retrieve the existing outlineIDs array from sessionStorage
        const storedOutlineIDs = sessionStorage.getItem("outlineIDs");
        let outlineIDs = storedOutlineIDs ? JSON.parse(storedOutlineIDs) : [];

        // Add the new outlineID to the array
        outlineIDs.push(newOutlineID);

        // Save the updated array back to sessionStorage
        sessionStorage.setItem("outlineIDs", JSON.stringify(outlineIDs));
        toast.success("Outline Successfully Added", {
          position: "top-right",
          autoClose: 3000,
        });
        fetchOutlines();
        setNewOutlineLoading(false);
      }
      setInputIndex(null);
      setNewOutline("");
    } catch (error: any) {
      if (error.response && error.response.status === 404) {
        toast.error("Upgrade to add more slides", {
          position: "top-right",
          autoClose: 3000,
        });
      } else {
        toast.error("Error adding outline", {
          position: "top-right",
          autoClose: 3000,
        });
      }
      console.error("Error adding outline:", error);
      setNewOutlineLoading(false);
    }
  };

  const handleDeleteOutline = async (index: number) => {
    if (!generatedDocumentIDoutline) return;

    setOutline((prevOutlines) => {
      const updatedOutlines = [...prevOutlines];
      const deletedItem = updatedOutlines.splice(index, 1);

      (async () => {
        try {
          await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/api/v1/outline/blocklist/delete`,
            {
              documentId: generatedDocumentIDoutline,
              index,
            },
            {
              headers: {
                Authorization: `Bearer ${authToken}`,
              },
            }
          );
          toast.success("Outline deleted successfully", {
            position: "top-right",
            autoClose: 3000,
          });
        } catch (error) {
          // Rollback on failure
          setOutline((current) => {
            const rollbackOutlines = [...current];
            rollbackOutlines.splice(index, 0, deletedItem[0]);
            return rollbackOutlines;
          });

          toast.error("Failed to delete outline. Please try again.", {
            position: "top-right",
            autoClose: 3000,
          });

          console.error("Error deleting outline:", error);
        }
      })();

      return updatedOutlines;
    });
  };
  const handleCloseModal = () => {
    setGeneratedDocumentIDoutline(null); // Reset ID when closing
    setIsRefineModalOpen(false);
  };
  useEffect(() => {
    if (websiteUrl) {
      setIsValidLink(urlRegex.test(websiteUrl));
    }
  }, [websiteUrl]); // Re-run validation when `websiteUrl` changes

  // 🎧 Listen for payment success from child window (NO POLLING!)
  useEffect(() => {
    let paymentChannel: BroadcastChannel | null = null;
    
    // Method 1: BroadcastChannel listener (modern browsers)
    if (typeof BroadcastChannel !== 'undefined') {
      paymentChannel = new BroadcastChannel('montypay_payment');
      
      paymentChannel.onmessage = (event) => {
        if (event.data.type === 'PAYMENT_SUCCESS') {
          console.log('✅ Payment success received via BroadcastChannel:', event.data);
          handlePaymentSuccess(event.data.orderId);
        }
      };
    }

    // Method 2: LocalStorage event listener (best cross-browser support)
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'montypay_payment_success' && e.newValue) {
        try {
          const data = JSON.parse(e.newValue);
          console.log('✅ Payment success received via localStorage:', data);
          handlePaymentSuccess(data.orderId);
        } catch (error) {
          console.error('Error parsing payment success data:', error);
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);

    // Method 3: PostMessage listener (for window.open scenarios)
    const handleMessage = (event: MessageEvent) => {
      // Verify origin for security
      if (event.origin !== window.location.origin) return;
      
      if (event.data.type === 'PAYMENT_SUCCESS') {
        console.log('✅ Payment success received via postMessage:', event.data);
        handlePaymentSuccess(event.data.orderId);
      }
    };

    window.addEventListener('message', handleMessage);

    // Cleanup on unmount
    return () => {
      if (paymentChannel) {
        paymentChannel.close();
      }
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('message', handleMessage);
    };
  }, []); // Empty dependency array - set up listeners once

  const generateDocumentID = () => {
    return "Document-" + Date.now();
  };
  const generatedDocumentID = generateDocumentID();

  // Prevent duplicate processing of the same orderId
  const processedPaymentsRef = useRef<Set<string>>(new Set());

  // 🎉 Handle payment success (NO POLLING!)
  const handlePaymentSuccess = async (orderId: string) => {
     if (!orderId) return;
   if (processedPaymentsRef.current.has(orderId)) {
     console.log('Duplicate payment event ignored for orderId:', orderId);
    return;   
   }
    processedPaymentsRef.current.add(orderId);
    try {
      console.log('🎉 Payment successful! Order ID:', orderId);
      
      // Close the pricing modal
      setIsPricingModalOpen(false);
      
      // Show success toast
      // toast.success('Payment successful! Your account has been upgraded.', {
      //   position: 'top-center',
      //   autoClose: 5000,
      // });

      // 🎁 Call exportHandler to process the successful payment
      // This will update pptlimit and trigger any post-payment actions
      
     const isSingle = !sessionStorage.getItem('isBundlePurchase'); // isBundle===true => bundle (add 3), otherwise single (add 1)
     await exportHanlder(isSingle);
     sessionStorage.removeItem('isBundlePurchase');
      // Refresh organization data to get updated plan
      if (orgId && authToken) {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organization/${orgId}`,
            {
              headers: {
                Authorization: `Bearer ${authToken}`,
              },
            }
          );

          const planName = response.data.plan.plan_name;
          const subscriptionId = response.data.plan.subscriptionId;
          setPptCount(response.data.pptcount);
          setPptCountMonthly(response.data.pptcount_monthly);
          setpptLimit(response.data.pptlimit);
          
          // Update Redux state
          dispatch(setUserPlan(planName));
          dispatch(setIsEligibleForDownload(
            response.data.pptcount >= 0 && response.data.pptlimit > 0
          ));
          setSubId(subscriptionId);

          if (planName === "pro" || planName === "custom" || response.data.is_eligible === true) {
            setEligibleForGeneration(true);
          } else {
            setEligibleForGeneration(false);
          }

          console.log('✅ Organization data refreshed successfully');
        } catch (error) {
          console.error('Error refreshing organization data:', error);
        }
      }
      
    } catch (error) {
      console.error('Error handling payment success:', error);
      toast.error('Payment processed, but failed to update UI. Please refresh the page.', {
        position: 'top-right',
        autoClose: 5000,
      });
    }
  };

  const MAX_FILE_SIZE_MB = 20; // Limit file size to 20MB

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setPDFUploading(true);

    if (event.target.files && event.target.files[0]) {
      const uploadedFile = event.target.files[0];

      // Check file size
      const fileSizeMB = uploadedFile.size / (1024 * 1024);
      if (fileSizeMB > MAX_FILE_SIZE_MB) {
        toast.error(
          `File size exceeds ${MAX_FILE_SIZE_MB}MB. Please upload a smaller file.`,
          {
            position: "top-right",
            autoClose: 3000,
          }
        );
        setPDFUploading(false);
        return;
      }

      setFile(uploadedFile);

      try {
        const pdfUploaded = {
          name: uploadedFile.name,
          type: uploadedFile.type,
          body: uploadedFile, // Pass the File object directly
        };
        // Handle upload
        const pdfLink = await uploadFileToS3(pdfUploaded);
        setPdfLink(pdfLink);
      } catch (error) {
        console.error("Error uploading file:", error);
        toast.error("Failed to upload file. Please try again.", {
          position: "top-right",
          autoClose: 3000,
        });
      } finally {
        setPDFUploading(false);
      }
    } else {
      setPDFUploading(false);
    }
  };

  const handleGenerate = () => {
    navigate(`/presentation-view?documentID=${generatedDocumentIDoutline}`);

    const quickGenerate = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/documentgenerate/generate-document/${orgId}/${generatedDocumentIDoutline}`,
          {
            pptInput: generateInput,
          },
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        );

        await response.data;
      } catch (error: any) {
        if (error.response?.status === 404) {
          toast.error("Error generating ppt", {
            position: "top-right",
            autoClose: 3000,
          });
        }
      }
    };

    const updatePptCount = async () => {
      await axios.patch(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organizationedit/${orgId}`,
        {
          pptcount: pptCount + 1,
          pptcount_monthly: pptCountMonthly + 1,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
    };

    quickGenerate();
    updatePptCount();
  };
  const handleSaveColors = async () => {
    setIsLoading(true); // Show loading state

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile//organization/updateColors/${orgId}`,
        { primaryColor, secondaryColor },
        { headers: { Authorization: `Bearer ${authToken}` } }
      );

      if (response.status === 200) {
        const colors = response.data.colors || organizationColors;

        // ✅ Build a colorMap with safe defaults
        const colorMap = {
          P100: colors.P100 || "#17191A",
          P75_S25: colors.P75_S25 || "#313B48",
          P50_S50: colors.P50_S50 || "#4A5C75",
          P25_S75: colors.P25_S75 || "#647EA3",
          S100: colors.S100 || "#7D9FD0",
          F_P100: colors.F_P100 || "#E8E8E8",
          F_P75_S25: colors.F_P75_S25 || "#E4E8EC",
          F_P50_S50: colors.F_P50_S50 || "#FFFFFF",
          F_P25_S75: colors.F_P25_S75 || "#FFFFFF",
          F_S100: colors.F_S100 || "#FFFFFF",
          SCL: colors.SCL || "#FFFFFF",
          SCD: colors.SCD || "#000000",
        };

        // Convert object values into arrays
        const colorArray: string[] = [
          colorMap.P100,
          colorMap.P75_S25,
          colorMap.P50_S50,
          colorMap.P25_S75,
          colorMap.S100,
        ];

        const colorArraySave: string[] = [
          colorMap.P100,
          colorMap.P75_S25,
          colorMap.P50_S50,
          colorMap.P25_S75,
          colorMap.S100,
          colorMap.F_P100,
          colorMap.F_P75_S25,
          colorMap.F_P50_S50,
          colorMap.F_P25_S75,
          colorMap.F_S100,
          colorMap.SCL,
          colorMap.SCD,
        ];

        await setBrandingColors([...colorArray]);
        await setBrandingColorsSave([...colorArraySave]);

        // ✅ Set individual color states
        setPrimaryColor(colorMap.P100);
        setTextColor(colorMap.F_P100);
        setSecondaryColor(colorMap.S100);
      }
    } catch (error) {
      console.error("Error updating branding colors:", error);
    } finally {
      setIsLoading(false); // Hide loading state
    }
  };

  // const handleRefinePPT = () => {
  //   const refinePPT = async () => {
  //     if (!file) {
  //       toast.info('Please upload a PDF to refine', {
  //         position: 'top-right',
  //         autoClose: 3000,
  //       })
  //       return
  //     }

  //     navigate(
  //       `/presentation-view?documentID=${generatedDocumentIDoutline}`
  //     )

  //     try {
  //       const response = await axios.post(
  //         `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/documentgenerate/generate-document/refineppt/${orgId}/${generatedDocumentIDoutline}`,
  //         {
  //           pdfLink: pdfLink,
  //         },
  //         {
  //           headers: {
  //             Authorization: `Bearer ${authToken}`,
  //           },
  //         }
  //       )

  //       await response.data
  //     } catch (error: any) {

  //     }
  //   }

  //   const updatePptCount = async () => {
  //     await axios.patch(
  //       `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organizationedit/${orgId}`,
  //       {
  //         pptcount: pptCount + 1,
  //         pptcount_monthly: pptCountMonthly + 1,
  //       },
  //       {
  //         headers: {
  //           Authorization: `Bearer ${authToken}`,
  //         },
  //       }
  //     )
  //   }
  //   refinePPT()
  //   updatePptCount()
  // }

  const updatePptCount = async () => {
    await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organizationedit/${orgId}`,
      {
        pptcount: pptCount + 1,
        pptcount_monthly: pptCountMonthly + 1,
      },
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    );
  };
  const isButtonDisabled =
    selectedType === 8
      ? !customTypeInput.trim() ||
        (userPlan !== "pro" && !eligibleForGeneration)
      : !selectedType || (userPlan !== "pro" && !eligibleForGeneration);

  // API CALL TO GET PRICING DATA FOR MODAL AND USER PLAN
  useEffect(() => {
    const getPricingData = async () => {
      const ipInfoResponse = await fetch("https://api.zynth.ai/api/v1/data/userprofile/ip-info");
      const ipInfoData: IpInfoResponse = await ipInfoResponse.json();

      await axios
        .get(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/appscripts/razorpay/plans`,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        )
        .then((response) => {
          const country = ipInfoData!.country!;
          if (country !== "IN" && country !== "India" && country !== "In") {
            setMonthlyPlan(response.data.items[4]);
            setYearlyPlan(response.data.items[2]);
            // setMonthlyPlan(response.data.items[1])
            // setYearlyPlan(response.data.items[0])
            setCurrency("USD");
          } else if (
            country === "IN" ||
            country === "India" ||
            country === "In"
          ) {
            setMonthlyPlan(response.data.items[5]);
            setYearlyPlan(response.data.items[3]);
            // setMonthlyPlan(response.data.items[1])
            // setYearlyPlan(response.data.items[0])
            setCurrency("INR");
          }
        });
    };

    const fetchUserPlan = async () => { 
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organization/${orgId}`,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        const planName = response.data.plan.plan_name;
        const subscriptionId = response.data.plan.subscriptionId;
        setPptCount(response.data.pptcount);
        setPptCountMonthly(response.data.pptcount_monthly);
        setpptLimit(response.data.pptlimit);
        if (planName === "pro" || response.data.is_eligible === true) {
          setEligibleForGeneration(true);
        } else {
          setEligibleForGeneration(false);
        }
        dispatch(setUserPlan(planName));
        (response.data.pptcount >= 0 && response.data.pptlimit > 0)? dispatch(setIsEligibleForDownload(true)) : dispatch(setIsEligibleForDownload(false));
        (response.data.pptlimit >= 0 && response.data.pptlimit <= response.data.pptcount)? setIsPricingModalOpen(true) : setIsPricingModalOpen(false);
        setSubId(subscriptionId);
      } catch (error) {
        console.error("Error fetching user plan:", error);
      }
    };

    fetchUserPlan();
    getPricingData();
  }, []);
  const monthlyPlanAmount = monthlyPlan?.item.amount! / 100;
  const monthlyPlanId = monthlyPlan?.id;
  const yearlyPlanAmount = yearlyPlan?.item.amount! / 100;
  const yearlyPlanId = yearlyPlan?.id;
  const Tooltip: React.FC<{ message: string }> = ({ message }) => {
    return (
      <div className="absolute left-8 bottom-10 w-72 bg-gray-800 text-white text-sm rounded-lg px-4 py-2 shadow-lg">
        {message}
      </div>
    );
  };
  const [visibleTooltip, setVisibleTooltip] = useState<string | null>(null);
 
  useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (!isHovered && visibleTooltip === "generate") {
      timeout = setTimeout(() => {
        setVisibleTooltip(null);
      }, 3000);
    }
    return () => clearTimeout(timeout);
  }, [isHovered, visibleTooltip]);

  const generateOutline = async () => {
    setLoading(true);
    setIsOutlineLoading(true);

    let docID = generatedDocumentIDoutline || generateDocumentID();
    setGeneratedDocumentIDoutline(docID);

    const payload = {
      pptInput: generateInput || "",
      pdfLink: pdfLink || "",
      deviceType: userAgent,
    };

    try {
      const requestUrl = `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/documentgenerate/generate-document/outline/${orgId}/${docID}`;

      const response = await axios.post(requestUrl, payload, {
        headers: { Authorization: `Bearer ${authToken}` },
      });

      if (response.status !== 200)
        throw new Error("Failed to generate outline");

      setOutline(response.data.outline);

      // ✅ Notify other components via Context API
      setIsOutlineGenerated(true);

      console.log("Outline generated successfully:", response.data.outline);
      setIsOutlineLoading(false);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        console.error("API Error:", error.response?.data || error.message);
      } else {
        console.error("Unexpected Error:", error);
      }
      setIsOutlineLoading(false);
    } finally {
      setLoading(false);
      console.log("Device Type:", userAgent);
      setIsOutlineLoading(false);
    }
  };

  const generateDocument = async () => {
    setLoading(true);
    navigate(`/presentation-view?documentID=${generatedDocumentIDoutline}`);
    if (!generatedDocumentIDoutline) {
      console.error("Error: Document ID is missing. Generate outline first.");
      setLoading(false);
      return;
    }
    const colorsToUse = brandingColorsSave.length
      ? brandingColorsSave
      : Object.values(organizationColors || {});

    const colorKeys = [
      "P100",
      "P75_S25",
      "P50_S50",
      "P25_S75",
      "S100",
      "F_P100",
      "F_P75_S25",
      "F_P50_S50",
      "F_P25_S75",
      "F_S100",
      "SCL",
      "SCD",
    ];

    const payload = {
      websiteUrl: websiteUrl || "",
      colors: colorKeys.reduce((acc: { [key: string]: string }, key, index) => {
        acc[key] = colorsToUse[index] || "#000000"; // Default to black if missing
        return acc;
      }, {} as { [key: string]: string }),
      creativity: creativity, // Number
      theme: theme, // String
      language:language|| "English",
      technicaldepth: technicalDepth=="Auto"?"Medium":technicalDepth,
    };

    try {
      const requestUrl = `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/documentgenerate/generate-document/${orgId}/${generatedDocumentIDoutline}`;
      console.log("Document Request URL:", requestUrl);
      console.log("Payload:", payload);

      const response = await axios.post(requestUrl, payload, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (response.status !== 200)
        throw new Error("Failed to generate document");

      const data = response.data;
      setOutline(data.outline);
      if(response.status==200){
      await updatePptCount();
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleButtonClick = async () => {
    try {
      const documentID = await generateDocument(); // Wait for completion
    } catch (error) {
      console.error("Error generating document:", error);
    }
  };

  const fetchOrganizationData = async () => {
    if (!orgId) {
      console.error("Error: Organization ID is missing.");
      return;
    }

    setLoading(true);
    const requestUrl = `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organization/${orgId}`;

    try {
      console.log("Fetching Organization Data:", requestUrl);

      const response = await axios.get(requestUrl, {
        headers: { Authorization: `Bearer ${authToken}` },
      });

      if (response.status !== 200) {
        throw new Error(`Failed to fetch data: ${response.statusText}`);
      }

      const data = response.data;
      console.log("Fetched Organization Data:", data);

      setWebsiteUrl(data.websiteLink || "");

      // Ensure colors exist before processing
      if (data.color && typeof data.color === "object") {
        const colorMap = {
          P100: data.color.P100 || "#17191A",
          P75_S25: data.color.P75_S25 || "#313B48",
          P50_S50: data.color.P50_S50 || "#4A5C75",
          P25_S75: data.color.P25_S75 || "#647EA3",
          S100: data.color.S100 || "#7D9FD0",
          F_P100: data.color.F_P100 || "#E8E8E8",
          F_P75_S25: data.color.F_P75_S25 || "#E4E8EC",
          F_P50_S50: data.color.F_P50_S50 || "#FFFFFF",
          F_P25_S75: data.color.F_P25_S75 || "#FFFFFF",
          F_S100: data.color.F_S100 || "#FFFFFF",
          SCL: data.color.SCL || "#FFFFFF",
          SCD: data.color.SCD || "#000000",
        };

        setBrandingColors([
          colorMap.P100,
          colorMap.P75_S25,
          colorMap.P50_S50,
          colorMap.P25_S75,
          colorMap.S100,
        ]);

        setOrganizationColors(colorMap);
        setPrimaryColor(colorMap.P100);
        setTextColor(colorMap.F_P100);
        setSecondaryColor(colorMap.S100);
      }
    } catch (error) {
      if (error instanceof Error) {
        console.error("Error fetching organization data:", error.message);
      } else {
        console.error("Error fetching organization data:", error);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrganizationData();
  }, [orgId, authToken]);
  // useEffect(() => {
  //   const fetchOrganizationData = async () => {
  //     if (!orgId) {
  //       console.error("Error: Organization ID is missing.");
  //       return;
  //     }

  //     setLoading(true);
  //     const requestUrl = `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organization/${orgId}`;

  //     try {
  //       console.log("Fetching Organization Data:", requestUrl);

  //       const response = await axios.get(requestUrl, {
  //         headers: { Authorization: `Bearer ${authToken}` },
  //       });

  //       if (response.status !== 200) {
  //         throw new Error(`Failed to fetch data: ${response.statusText}`);
  //       }

  //       const data = response.data;
  //       console.log("Fetched Organization Data:", data);

  //       setWebsiteUrl(data.websiteLink || "");

  //       // Ensure colors exist before processing
  //       if (data.color && typeof data.color === "object") {
  //         const colorMap = {
  //           P100: data.color.P100 || "#000000",
  //           P75_S25: data.color.P75_S25 || "#290000",
  //           P50_S50: data.color.P50_S50 || "#520000",
  //           P25_S75: data.color.P25_S75 || "#7A0000",
  //           S100: data.color.S100 || "#a30000",
  //           F_P100: data.color.F_P100 || "#FFFFFF",
  //           F_P75_S25: data.color.F_P75_S25 || "#FFFFFF",
  //           F_P50_S50: data.color.F_P50_S50 || "#FFFFFF",
  //           F_P25_S75: data.color.F_P25_S75 || "#E9E9E9",
  //           F_S100: data.color.F_S100 || "#EADFF2",
  //           SCL: data.color.SCL || "#FFFFFF",
  //           SCD: data.color.SCD || "#000000",
  //         };

  //         setBrandingColors([
  //           colorMap.P100,
  //           colorMap.P75_S25,
  //           colorMap.P50_S50,
  //           colorMap.P25_S75,
  //           colorMap.S100,
  //         ]);

  //         setOrganizationColors(colorMap);
  //         setPrimaryColor(colorMap.P100);
  //         setTextColor(colorMap.F_P100);
  //         setSecondaryColor(colorMap.S100);
  //       }
  //     } catch (error) {
  //       if (error instanceof Error) {
  //         console.error("Error fetching organization data:", error.message);
  //       } else {
  //         console.error("Error fetching organization data:", error);
  //       }
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchOrganizationData();
  // }, [orgId, authToken]);

  const [showCreativityTooltip, setShowCreativityTooltip] = useState(false);

  const exportHanlder = async (isSingleExport :boolean=false)=>{
    // try{
      
    //    const paymentButton = document.getElementById("payment-button");
    //     if (paymentButton) {
    //       paymentButton.click();
    //     } else {
    //       console.error("Payment button not found");isel
    //     }
    // }
    // catch(error){
    //   console.log(error);
    // }
    try{

       const getOrgProfile = await axios.get(
              `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organization/${orgId}`,
              {
                headers: {
                  Authorization: `Bearer ${authToken}`,
                },
              }
            );
            if (getOrgProfile.status !== 200) {
              console.error("Non-200 response:", getOrgProfile.status);
              return;
            }
       const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organizationedit/${orgId}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
          body: JSON.stringify({ pptlimit: getOrgProfile.data.pptlimit+(isSingleExport ? 1 : 3) }),
        }
      );
      setIsPricingModalOpen(false)
      dispatch(setIsEligibleForDownload(true))
      
      // Download PDF on first purchase (when pptlimit was 0 before payment)
      if(getOrgProfile.data.pptlimit == 0){
        // Download PDF using blob approach (like Navbar)
        const pdfUrl = 'https://zynthimages.s3.us-east-1.amazonaws.com/pdf/The_Orca_Blueprint.pdf';
        try {
          const response = await fetch(pdfUrl, { mode: 'cors' });
          if (!response.ok) {
            throw new Error(`Failed to fetch file: ${response.status}`);
          }
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'The_Orca_Blueprint_Letter_21.pdf';
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
        } catch (err) {
          console.error('Download failed:', err);
          // Fallback: if fetch fails, attempt normal navigation to the file
          window.open(pdfUrl, '_blank');
        }
      }
      toast.success("Payment Successful!", {
          position: "top-center",
          autoClose: 3000,
        });

    }
    catch(error){
      console.log(error);
      //  toast.error("Payment UnSuccessful!", {
      //     position: "top-right",
      //     autoClose: 3000,
      //   });
       // Keep an error toast for failures during the limit update
       toast.error("Failed to update purchase status. Please contact support.", {
         position: "top-right",
         autoClose: 3000,
       });
    }
  }


   const getWebsiteData= async () => {
    try{
      const payload = {
        websiteUrl: websiteUrl || "",
        webSearchToogle:includeWebSearch || false,
      }
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/documentgenerate/get-website-data/${orgId}/${generatedDocumentIDoutline}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
        if (res.status !== 200)
        throw new Error("Failed to generate presentation");

      const data = res.data;
    }
    catch(error){
      console.error("Error fetching website data:", error);
    }
  };


  const onSuccessHandler =async ()=>{
    try{

       const getOrgProfile = await axios.get(
              `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organization/${orgId}`,
              {
                headers: {
                  Authorization: `Bearer ${authToken}`,
                },
              }
            );
            if (getOrgProfile.status !== 200) {
              console.error("Non-200 response:", getOrgProfile.status);
              return;
            }
       const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organizationedit/${orgId}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
          body: JSON.stringify({ pptlimit: getOrgProfile.data.pptlimit+3 }),
        }
      );
      setIsPricingModalOpen(false);
      dispatch(setIsEligibleForDownload(true));
      
      // Download PDF on first purchase (when pptlimit was 0 before payment)
      if(getOrgProfile.data.pptlimit == 0){
        // Download PDF using blob approach (like Navbar)
        const pdfUrl = 'https://zynthimages.s3.us-east-1.amazonaws.com/pdf/The_Orca_Blueprint.pdf';
        try {
          const response = await fetch(pdfUrl, { mode: 'cors' });
          if (!response.ok) {
            throw new Error(`Failed to fetch file: ${response.status}`);
          }
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'The_Orca_Blueprint_Letter_21.pdf';
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
        } catch (err) {
          console.error('Download failed:', err);
          // Fallback: if fetch fails, attempt normal navigation to the file
          window.open(pdfUrl, '_blank');
        }
      }

    }
    catch(error){
      console.log(error);
    }
  }
  const onPaymentFailure= async()=>{

  }

  return (
<div
  className="relative flex p-4 flex-col items-center justify-center h-screen w-screen"
  style={{
    background: `linear-gradient(to bottom right, 
      ${Theme.colors.gradient.secondary1}, 
      ${Theme.colors.gradient.primary1}, 
      ${Theme.colors.background})`,
  }}
>

      <div className="relative  w-full    text-center flex flex-col items-center mt-[-20vh]">
        <div className="absolute inset-0z-[-1] rounded-2xl"></div>
        <h2
  className="text-2xl font-semibold mb-8"
  style={{ color: Theme.colors.text.strong }}
>
          Tell us what you want to build
        </h2>
        <p
  className="flex items-center gap-1 relative text-lg"
  style={{ color: Theme.colors.text.weak }}
>
          Enter your pitch deck context.
          <span
  className="cursor-pointer relative"
  style={{ color: Theme.colors.primary }}
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
          >
     <FaInfoCircle
  className="cursor-pointer relative"
  style={{ color: Theme.colors.primary }}
/>

            {showTooltip && (
              <div
  className="absolute z-50 hidden lg:block left-full ml-2 transform -translate-y-1/2 w-72 p-3 text-xs rounded-lg shadow-lg opacity-100 transition-opacity duration-300 text-left"
  style={{
    backgroundColor: Theme.colors.grounding,
    color: Theme.colors.background,
  }}
>

                <p className="font-semibold">
                  Provide clear details about your presentation requirements.
                  The more specific you are, the more relevant the output will
                  be.
                </p>
                <p>
                  {" "}
                  - Outline the objective and key message of the presentation.
                </p>
                <p>
                  - Specify any required slides, information, or data to
                  include.
                </p>
                <p>
                  - Provide detailed instructions to ensure alignment with your
                  vision.
                </p>
              </div>
            )}
            {showTooltip && (
              <div
              className="absolute z-50 top-0 lg:hidden left-[80%] -translate-x-[80%] -translate-y-[80%] w-72 p-3 text-xs rounded-lg shadow-lg opacity-100 transition-opacity duration-300 text-left"
              style={{
                backgroundColor: Theme.colors.grounding,
                color: Theme.colors.background,
              }}
            >
            
                <p className="font-semibold">
                  Provide clear details about your presentation requirements.
                  The more specific you are, the more relevant the output will
                  be.
                </p>
                <p>
                  - Outline the objective and key message of the presentation.
                </p>
                <p>
                  - Specify any required slides, information, or data to
                  include.
                </p>
                <p>
                  - Provide detailed instructions to ensure alignment with your
                  vision.
                </p>
              </div>
            )}
          </span>
        </p>
        <div className=" relative mt-2 w-full flex justify-center">
          {/* <textarea
            className="lg:w-1/2 h-[7rem]  w-full text-[#091220] py-2 px-4 rounded-xl scrollbar-none resize-none"
            placeholder="Add text or drop content here — more details mean a more tailored presentation!"
            value={generateInput || ""}
            onChange={(e) => setGenerateInput(e.target.value)}
            minLength={100}
            maxLength={10000}
          ></textarea>
          <div
            className={`lg:w-1/2 w-full text-right text-sm mt-1 lg:ml-6 ${
              generateInput.length < 100 ? "text-red-500" : "text-green-600"
            }`}
          >
            {generateInput.length}
          </div> */}
          <div className="relative lg:w-1/2 w-full">
          <textarea
  className="h-[7rem] w-full py-2 px-4 rounded-xl scrollbar-none resize-none border focus:outline-none focus:ring-2"
  style={{
    color: Theme.colors.text.strong,
    backgroundColor: Theme.colors.background,
    borderColor: Theme.colors.stroke.weak,
    fontFamily: Theme.font.family,
    outlineColor: Theme.colors.primary,
  }}
  placeholder="Add text or drop content here — more details mean a more tailored presentation!"
  value={generateInput || ""}
  onChange={(e) => setGenerateInput(e.target.value)}
  minLength={100}
  maxLength={10000}
/>


    
{generateInput.length > 0 && (
  <div
    className="absolute bottom-2 right-3 text-sm"
    style={{
      color:
  (!file && generateInput.length < 100) ? 'red'
          : Theme.colors.text.strong,
    }}
  >
    {generateInput.length}
  </div>
)}

  </div>
        </div>
        <div
  className="border-t my-8 relative w-full items-center justify-center"
  style={{ borderColor: Theme.colors.stroke.weak }}
>

          <span className="absolute top-[-15px] left-1/2 transform -translate-x-1/2  px-2 font-bold text-lg">
            or
          </span>
        </div>
        <p
  className="mb-2 mt-2 flex items-center gap-1 relative text-lg"
  style={{ color: Theme.colors.text.weak }}
>
  Refine an existing pitch deck.
  <span
    className="cursor-pointer relative"
    onMouseEnter={() => setShowTooltip1(true)}
    onMouseLeave={() => setShowTooltip1(false)}
    style={{ color: Theme.colors.primary }}
  >
    <FaInfoCircle
      className="relative"
      style={{ color: Theme.colors.primary }}
    />

    {showTooltip1 && (
      <div
        className="absolute hidden lg:block text-left bottom-8 w-72 p-3 text-xs rounded-lg shadow-lg transition-opacity duration-300 opacity-100"
        style={{
          backgroundColor: Theme.colors.grounding,
          color: Theme.colors.background,
        }}
      >
        <p className="font-semibold">Refine an existing document:</p>
        <p>
          Upload a document to refine and transform it into a visually stunning
          presentation
        </p>
      </div>
    )}
                 
    {showTooltip1 && (
      <div
        className=" absolute lg:hidden left-1/5 -translate-x-2/3 bottom-8 w-[60vw] max-w-[calc(100vw-2rem)] p-3 text-xs rounded-lg shadow-lg opacity-100 transition-opacity duration-300 z-50"
        style={{
          backgroundColor: Theme.colors.grounding,
          color: Theme.colors.background,
        }}
      >
        <p className="font-semibold">Refine an existing document:</p>
        <p>
          Upload a document to refine and transform it into a visually stunning
          presentation
        </p>
      </div>
    )}
  </span>
</p>

<div className="w-[80%] lg:w-1/4 justify-center">
  {pdfUploading && (
    <div
      className="flex items-center justify-center h-[3.1rem] mt-2 py-2 px-4 rounded-xl"
      style={{
        backgroundColor: Theme.colors.background,
        border: `1px solid ${Theme.colors.stroke.strong}`,
        color: Theme.colors.text.strong,
      }}
    >
      <span>Uploading...</span>
    </div>
  )}

  {file && !pdfUploading && (
    <div
      className="flex items-center justify-center h-[3.1rem] py-2 px-4 rounded-xl"
      style={{
        backgroundColor: Theme.colors.background,
        border: `1px solid ${Theme.colors.stroke.strong}`,
        color: Theme.colors.text.strong,
      }}
    >
      <span className="truncate" style={{ color: Theme.colors.text.weak }}>
        {file.name}
      </span>
      <button
        className="ml-2"
        style={{ color: Theme.colors.stroke.strong }}
        onClick={() => {
          setFile(null);
          setPdfLink("");
        }}
      >
        <FaTimes />
      </button>
    </div>
  )}

  {!file && (
    <label
      className="flex items-center justify-center h-[3.1rem] border py-2 px-4 rounded-xl cursor-pointer"
      style={{
        backgroundColor: Theme.colors.background,
        color: Theme.colors.text.strong,
        borderColor: Theme.colors.stroke.strong,
      }}
    >
      <FaUpload
        className="mr-2"
        style={{ color: Theme.colors.text.weak }}
      />
      <span>Upload a Document</span>
      <input
        type="file"
        accept=".pdf, .doc, .docx, .ppt, .pptx"
        className="hidden"
        onChange={handleFileChange}
      />
    </label>
  )}
</div>

        <div
          className=" flex justify-center mt-8 relative"
          onMouseEnter={() => {
            setIsHovered(true);
          }}
          onMouseLeave={() => {
            setTimeout(() => setIsHovered(false), 3000); // Hide after 3 seconds
          }}
        >
          <button
            id="generate-presentation"
            onClick={() => {
              if(pptCount>=pptLimit){
                setIsPricingModalOpen(true);
                setUserPlan("free");
                return 
              }
              setIsRefineModalOpen(true);
              generateOutline(); // Call the function
            
            }}
            disabled={
              (!file && !generateInput) || (!file && generateInput && generateInput.length<100)||
              pdfUploading
              //  ||
              // !eligibleForGeneration
            }
            className={`h-[3.1rem] px-16 py-4 rounded-lg font-semibold active:scale-95 transition transform duration-300 flex items-center justify-center ${
             (!file && !generateInput) || (!file && generateInput && generateInput.length<100)||
              pdfUploading
              //  ||
              // !eligibleForGeneration 
              //||
              //generateInput.length < 100
                ? "cursor-not-allowed"
                : "hover:opacity-90"
            }`}
            style={{
              backgroundColor:
                 (!file && !generateInput) ||(!file && generateInput && generateInput.length<100)||
                pdfUploading
                //  ||
                // !eligibleForGeneration
                  ? Theme.colors.stroke.strong
                  : Theme.colors.primary,
              color: "#FFFFFF",
              cursor:
                 (!file && !generateInput) ||
                pdfUploading
                //  ||
                // !eligibleForGeneration
                 ||(!file && generateInput && generateInput.length<100)
                  ? "not-allowed"
                  : "pointer",
            }}
            
          >
            Submit
          </button>
          {isHovered && (
            <>
  { !file && generateInput.length < 100 ? (
    <div
      className="absolute top-full mt-2 w-[14rem] p-2 rounded-2xl shadow-lg flex items-center justify-center opacity-100 transition-opacity duration-300"
      style={{
        backgroundColor: Theme.colors.stroke.weak,
        color: Theme.colors.text.default,
      }}
    >
      <p className="text-sm text-center" style={{ color: Theme.colors.text.weak }}>
        Please provide minimum 100 characters in presentation context
      </p>
    </div>
  ) :()=>{}
  //  !eligibleForGeneration ?()
  // //  (
  // //   <div
  // //     className="absolute top-full mt-2 w-[14rem] p-2 rounded-2xl shadow-lg flex items-center justify-center opacity-100 transition-opacity duration-300"
  // //     style={{
  // //       backgroundColor: Theme.colors.stroke.weak,
  // //       color: Theme.colors.text.default,
  // //     }}
  // //   >
  // //     <p className="text-sm text-center" style={{ color: Theme.colors.text.weak }}>
  // //       Please{" "}
  // //       <span
  // //         onClick={() => setIsPricingModalOpen(true)}
  // //         className="font-semibold hover:underline cursor-pointer"
  // //         style={{ color: Theme.colors.primary }}
  // //       >
  // //         upgrade
  // //       </span>{" "}
  // //       to generate more presentations.
  // //     </p>
  // //   </div>
  // // ) 
  // : null
  }
</>

          )}
        </div>
      </div>

      {/* Pricing Modal */}
      {isPricingModalOpen && (pptCount >= pptLimit) ? (
        // <PricingModal
        //   closeModal={() => {
        //     setIsPricingModalOpen(false);
        //   }}
        //   heading={pricingModalHeading}
        //   subscriptionId={subId}
        //   monthlyPlanAmount={monthlyPlanAmount}
        //   yearlyPlanAmount={yearlyPlanAmount}
        //   currency={currency}
        //   monthlyPlanId={monthlyPlanId!}
        //   yearlyPlanId={yearlyPlanId!}
        //   authToken={authToken!}
        //   orgId={orgId!}
        // />
        <PricingModalNew
          closeModal={async () => {
            setIsPricingModalOpen(false);
            // checkExportStatus();
            
            // Check if feedback exists before showing modal
            // const shouldShowFeedback = await checkFeedbackExists();
            // if (shouldShowFeedback) {
            //   setShowFeedbackModal(true);
            // }
            
            // dispatch(setOpenPricingModal(false));
          }}
           currency={currency}
          exportButtonText={`${currency === "INR" ? "₹" : "$"} ${
            isDiscounted ? discountedAmount : currentAmount
          }`}
          exportButtonBundleText={`${currency == "INR" ? "₹" : "$"} ${
            isDiscounted ? bundleDiscountedAmount : bundleCurrentAmount
          }`}
          exportHandler={exportHanlder}
          setIsBundle={setIsBundle}
          savings={`${currency=="INR"?"₹" : "$"} ${isDiscounted?bundleCurrentAmount-bundleDiscountedAmount:0}`}
          
        />
      ) : (
        <></>
      )}

      <PaymentGateway
              key={isBundle ? "bundle" : "single"} 
              productinfo="Presentation Export"
              onSuccess={onSuccessHandler}
              onFailure={onPaymentFailure}
              formId={"Document-2324424242"}
              authToken={authToken!}
              isDiscounted={isDiscounted}
              discountedAmount={isBundle ? bundleDiscountedAmount : discountedAmount}
              originalAmount={isBundle ? bundleCurrentAmount:currentAmount}
            />

      {/* Refine Modal */}
       {isRefineModalOpen && (
        <div
          className="fixed inset-0 z-30 flex justify-center items-center"
          style={{ backgroundColor: "rgba(23, 25, 26, 0.3)" }}
        >
          <div
            className="relative w-[90%] sm:w-[80%] h-[90%] max-w-6xl bg-white rounded-2xl shadow-xl p-2 xs:p-6 flex flex-col"
            style={{ backgroundColor: Theme.colors.background }}
          >
            {/* Close Button */}
            <button
              title="CloseModal"
              onClick={handleCloseModal}
              className="absolute top-4 right-4 p-2 bg-gray-200 rounded-full z-10"
            >
              <FaTimes style={{ color: Theme.colors.text.weak }} />
            </button>

            {/* Header with Tabs and Generate Button */}
            <div className="flex w-full items-center  border-b border-gray-300 mb-4">
              {/* Tabs Container */}
               <button
                  onClick={() => setActiveTab("options")}
                  className={`py-2 px-4 font-semibold transition-all`}
                  style={{
                    color: activeTab === "options" ? Theme.colors.primary : Theme.colors.text.weak,
                    borderBottom: activeTab === "options" ? `4px solid ${Theme.colors.primary}` : undefined,
                  }}
                >
                  Presentation Options
                </button> 
              <div className="flex items-center">
                <button
                  onClick={() => {
                    if(isOutlineReviewed){
                      setActiveTab("outline");
                    }
                    else{
                      toast.info("Please review the outline first.", {
                        position: "top-center",
                        autoClose: 3000,
                      });
                    }
                  }}
                  className={`py-2 px-4 font-semibold transition-all`}
                  style={{
                    color: activeTab === "outline" ? Theme.colors.primary : Theme.colors.text.weak,
                    borderBottom: activeTab === "outline" ? `4px solid ${Theme.colors.primary}` : undefined,
                  }}
                >
                  Presentation Outline
                </button>
               
              </div>
            </div>

            <div className="w-full h-full overflow-y-auto scrollbar-none mt-2">
              {activeTab === "options" ? 
              
              (
                <>
                  <div className="flex flex-col overflow-y-auto pr-2 max-h-[70vh] ">
                    {/* Scrollable Form Content */}
                    <div className="flex-1 overflow-y-auto space-y-6 px-1 ">
                      {/* Reference Web URL + Language + Web Search Side-by-Side on lg */}
                      <div className="flex flex-col lg:flex-row gap-6">
                        {/* Reference Web URL */}
                        <div className="flex-1 space-y-2">
                          <label
                            className="font-semibold flex items-center gap-2"
                            style={{ color: Theme.colors.text.strong }}
                          >
                            Reference Web URL (optional)
                            <span
                              className="cursor-pointer relative"
                              style={{ color: Theme.colors.primary }}
                              onMouseEnter={() => {
                                setShowTooltip3(true);
                              }}
                              onMouseLeave={() => {
                                setShowTooltip3(false);
                              }}
                            >
                              <FaInfoCircle className="text-base" />
                              {showTooltip3 && (
                                <div
                                  className="absolute text-left top-[7%] left-[90%] w-72 p-3 text-xs rounded-lg shadow-lg transform -translate-x-1/2 transition-opacity duration-300 opacity-100 z-50"
                                  style={{
                                    backgroundColor: Theme.colors.grounding,
                                    color: Theme.colors.background,
                                    zIndex: 9999,
                                  }}
                                >
                                  <p className="font-semibold">
                                    Why add a rexference URL?
                                  </p>
                                  <p>
                                    Provide a web URL from which you would like
                                    us to include information for the
                                    presentation.
                                  </p>
                                </div>
                              )}
                            </span>
                          </label>

                          <input
                            type="text"
                            value={websiteUrl}
                            onChange={(e) => {
                              const updatedValue = e.target.value;
                              if (updatedValue === "") {
                                setWebsiteUrl("");
                                setIsValidLink(true);
                                return;
                              }
                              setWebsiteUrl(updatedValue);
                              const urlRegex =
                                /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
                              setIsValidLink(urlRegex.test(updatedValue));
                            }}
                            onFocus={() => {
                              if (!websiteUrl) setWebsiteUrl("https://");
                            }}
                            className={`w-full p-2 border rounded-lg shadow-sm outline-none focus:ring-2 ${
                              websiteUrl.length > 0 && !isValidLink
                                ? "border-red-500"
                                : "border-gray-300"
                            }`}
                            style={{
                              outlineColor: websiteUrl.length > 0 && !isValidLink ? Theme.colors.error : Theme.colors.primary,
                            }}
                            placeholder="Enter website URL"
                          />
                          {websiteUrl.length > 0 && !isValidLink && (
                            <p className="text-red-500 text-sm">
                              Please enter a valid website link.
                            </p>
                          )}
                        </div>

                        {/* Language and Web Search Container */}
                        <div className="flex-1 space-y-2">
                          {/* Language and Web Search - Side by side on lg, stacked on smaller screens */}
                          <div className="flex flex-col lg:flex-row lg:gap-8 space-y-2 lg:space-y-0">
                            {/* Language */}
                            {/* <div className="flex-1 space-y-2">
                              <label className="font-semibold flex items-center gap-2">
                                Language (optional)
                                <span className="cursor-pointer text-primary">
                                  <FaInfoCircle
                                    style={{
                                      color: Theme.colors.primary,
                                    }}
                                  />
                                </span>
                              </label>
                              <select
                                title="Language"
                                value={language}
                                onChange={(e) => setLanguage(e.target.value)}
                                className="w-full p-2 border rounded-lg shadow-sm focus:ring-2 focus:outline-none border-gray-300"
                                style={{ outlineColor: Theme.colors.primary }}
                              >
                                <option value="">Select a language</option>
                                {supportedLanguages.map((lang) => (
                                  <option key={lang} value={lang}>
                                    {lang}
                                  </option>
                                ))}
                              </select>
                              {language &&
                                !supportedLanguages.includes(language) && (
                                  <p className="text-red-500 text-sm">
                                    Unsupported language selected.
                                  </p>
                                )}
                            </div> */}

                            {/* Include Web Search Toggle */}
                            <div className="flex-1 space-y-2 lg:max-w-[200px]">
                              <label className="font-semibold flex items-center gap-2">
                                Include Web Search
                                <span
                                  className="cursor-pointer relative"
                                  style={{ color: Theme.colors.primary }}
                                  onMouseEnter={() => {
                                    setShowTooltip5(true);
                                  }}
                                  onMouseLeave={() => {
                                    setShowTooltip5(false);
                                  }}
                                >
                                  <FaInfoCircle className="text-base" />
                                  {showTooltip5 && (
                                    <div
                                      className="absolute text-left top-[7%]  right-[5%] w-72 p-3 text-xs rounded-lg shadow-lg transform -translate-x-1/2 transition-opacity duration-300 opacity-100 z-50"
                                      style={{
                                        backgroundColor: Theme.colors.grounding,
                                        color: Theme.colors.background,
                                        zIndex: 9999
                                      }}
                                    >
                                      <p className="font-semibold">What is Include Web Search?</p>
                                      <p>
                                      Enable to include relevant web search results on your presentation topic in the generated content.
                                      </p>
                                    </div>
                                  )}
                                </span>
                              </label>
                              <div className="flex items-center">
                                <button
                                  type="button"
                                  onClick={() =>
                                    setIncludeWebSearch(!includeWebSearch)
                                  }
                                  className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 ${
                                      includeWebSearch
                                        ? ""
                                        : "bg-gray-200"
                                    }`}
                                  style={{ backgroundColor: includeWebSearch ? Theme.colors.primary : undefined }}
                                >
                                  <span
                                    className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                                      includeWebSearch
                                        ? "translate-x-6"
                                        : "translate-x-1"
                                    }`}
                                  />
                                </button>
                                <span className="ml-3 text-sm text-gray-600">
                                  {includeWebSearch ? "On" : "Off"}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="space-y-6">
                        {/* Branding Colors */}
                        <div>
                          <div className="flex items-center relative">
                            <label
                              className="font-semibold"
                              style={{ color: Theme.colors.text.strong }}
                            >
                              Branding Colors
                            </label>
                            <div
                              className="relative flex items-center ml-2"
                              onMouseEnter={() => setShowTooltip4(true)}
                              onMouseLeave={() => setShowTooltip4(false)}
                            >
                              <FaInfoCircle
                                className="cursor-pointer"
                                style={{ color: Theme.colors.primary }}
                              />
                              {showTooltip4 && (
                                <div
                                  className="hidden lg:absolute lg:block lg:text-left lg:left-1/2 lg:bottom-8 lg:w-72 lg:p-3 text-xs rounded-lg shadow-lg lg:transform lg:-translate-x-1/2 transition-opacity duration-300 lg:opacity-100"
                                  style={{
                                    backgroundColor: Theme.colors.grounding,
                                    color: Theme.colors.background,
                                  }}
                                >
                                  <p className="font-semibold">
                                    Branding Colors
                                  </p>
                                  <p>
                                    These are the colors that will be used in
                                    your presentation. If you've uploaded a
                                    logo, the colors have been extracted from
                                    it.
                                  </p>
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="flex justify-between items-center gap-2 lg:gap-0 mt-4 w-full">
                            <div
                              className="flex w-2/3 h-10 rounded-lg overflow-hidden border-2 shadow-md"
                              style={{
                                borderColor: Theme.colors.stroke.weak,
                              }}
                            >
                              {isLoading ? (
                                <p
                                  className="flex items-center justify-center w-full"
                                  style={{ color: Theme.colors.text.weak }}
                                >
                                  Loading colors...
                                </p>
                              ) : (
                                brandingColors?.map((color, index) => (
                                  <div
                                    key={index}
                                    className="h-full flex-1"
                                    style={{ backgroundColor: color }}
                                  />
                                ))
                              )}
                            </div>

                            <button
                              className={`lg:h-[2.5rem] text-xs font-medium px-4 py-2 rounded-md active:scale-95 transition transform duration-300 ${
                                isLoading ? "opacity-50 cursor-not-allowed" : ""
                              }`}
                              style={{
                                backgroundColor: Theme.colors.background,
                                color: Theme.colors.primary,
                                border: `1px solid ${Theme.colors.primary}`,
                              }}
                              disabled={isLoading}
                              onClick={() => !isLoading && setIsModalOpen(true)}
                            >
                              Change branding colors
                            </button>
                          </div>
                        </div>
                        {/* Theme Selection */}
                        <div
                          className="flex flex-col space-y-3 p-4 rounded-lg shadow-sm"
                          style={{
                            backgroundColor: Theme.colors.stroke.weak,
                          }}
                        >
                          {/* Label with Relaxed Hover Tooltip */}
                          <div className="relative w-max">
                            <label
                              className="font-semibold flex items-center gap-2"
                              style={{ color: Theme.colors.text.strong }}
                            >
                              Choose a Theme
                              <span
                                className="cursor-pointer relative"
                                onMouseEnter={() => setShowThemeTooltip(true)}
                                onMouseLeave={() => setShowThemeTooltip(false)}
                                style={{ color: Theme.colors.primary }}
                              >
                                <FaInfoCircle className="text-base" />
                                {showThemeTooltip && (
                                  <div
                                    className="hidden lg:absolute lg:block text-left left-1/2 bottom-8 w-72 p-3 text-xs rounded-lg shadow-lg opacity-100 transform -translate-x-1/2 transition-opacity duration-300"
                                    style={{
                                      backgroundColor: Theme.colors.grounding,
                                      color: Theme.colors.background,
                                    }}
                                  >
                                    <p className="font-semibold">
                                      How do themes work?
                                    </p>
                                    <p>
                                      Choose how your slides will appear. All
                                      themes incorporate your brand colors for
                                      text and accents.
                                    </p>
                                  </div>
                                )}
                              </span>
                            </label>
                          </div>

                          <div className="flex justify-between mt-2 gap-3">
                            {[
                              {
                                name: "Light",
                                backgroundColor: Theme.colors.background,
                                textColor: Theme.colors.text.default,
                                borderColor: Theme.colors.stroke.weak,
                                tooltip:
                                  "White background with brand colors for text & accents.",
                              },
                              {
                                name: "Dark",
                                backgroundColor: Theme.colors.grounding,
                                textColor: Theme.colors.background,
                                borderColor: Theme.colors.stroke.strong,
                                tooltip:
                                  "Black background with brand colors for text & accents.",
                              },
                              {
                                name: "Branded",
                                backgroundColor: primaryColor,
                                textColor: textColor,
                                borderColor: primaryColor,
                                tooltip:
                                  "Background in your brand’s main color.",
                              },
                            ].map(
                              ({
                                name,
                                backgroundColor,
                                textColor,
                                borderColor,
                                tooltip,
                              }) => (
                                <div
                                  key={name}
                                  className="relative w-1/3"
                                  onMouseEnter={() => setHoveredTheme(name)}
                                  onMouseLeave={() => setHoveredTheme(null)}
                                >
                                  <button
                                    onClick={() => setTheme(name)}
                                    className={`w-full py-2 rounded-lg border-2 font-semibold text-center transition-all ${
                                      theme === name
                                        ? "scale-105 shadow-md"
                                        : ""
                                    } hover:scale-105 hover:shadow-lg`}
                                    style={{
                                      backgroundColor,
                                      color: textColor,
                                      borderColor:
                                        theme === name
                                          ? Theme.colors.primary
                                          : borderColor,
                                    }}
                                  >
                                    {name}
                                  </button>

                                  {/* Tooltip for Individual Themes */}
                                  {hoveredTheme === name && (
                                    <div
                                      className="hidden lg:absolute lg:bottom-full lg:left-1/2 lg:transform lg:-translate-x-1/2 lg:mb-2 w-max rounded px-3 py-2 shadow-lg opacity-100 transition-opacity duration-200 text-xs"
                                      style={{
                                        backgroundColor: Theme.colors.grounding,
                                        color: Theme.colors.background,
                                      }}
                                    >
                                      {tooltip}
                                    </div>
                                  )}
                                </div>
                              )
                            )}
                          </div>
                        </div>

                        {/* Creativity Slider */}
                        <div
                          className="flex flex-col space-y-3 p-4 rounded-lg shadow-sm"
                          style={{
                            backgroundColor: Theme.colors.stroke.weak,
                          }}
                        >
                          {/* Label, Info Icon, and Value Display */}
                          <div className="flex justify-between gap-1 items-center">
                            <div className="relative text-sm leading-snug">
                              <span
                                className="inline-flex items-center gap-1 flex-wrap font-semibold text-base"
                                style={{ color: Theme.colors.text.strong }}
                              >
                                Adjust Creativity
                                <span
                                  className="cursor-pointer"
                                  onMouseEnter={() =>
                                    setShowCreativityTooltip(true)
                                  }
                                  onMouseLeave={() =>
                                    setShowCreativityTooltip(false)
                                  }
                                  style={{ color: Theme.colors.primary }}
                                >
                                  <FaInfoCircle className="text-base inline" />
                                  {showCreativityTooltip && (
                                    <div
                                      className="hidden lg:block absolute text-left left-1/2 bottom-8 w-72 p-3 text-xs rounded-lg shadow-lg opacity-100 transform -translate-x-1/2 transition-opacity duration-300"
                                      style={{
                                        backgroundColor: Theme.colors.grounding,
                                        color: Theme.colors.background,
                                      }}
                                    >
                                      <p className="font-semibold">
                                        How does Creativity affect text?
                                      </p>
                                      <p>
                                        Adjust how creative or structured the
                                        generated text should be...
                                      </p>
                                    </div>
                                  )}
                                </span>
                              </span>
                            </div>

                            <span
                              className="font-medium"
                              style={{ color: Theme.colors.text.strong }}
                            >
                              Creativity: {creativity.toFixed(1)}
                            </span>
                          </div>

                          {/* Styled Slider */}
                          <input
                            type="range"
                            min="0"
                            max="10"
                            step="0.1"
                            value={creativity}
                            onChange={(e) => {
                              let newValue = Number(e.target.value);
                              newValue = Math.max(0, Math.min(10, newValue)); // Keep within range
                              setCreativity(newValue);
                            }}
                            className="w-full h-2 rounded-lg transition-all appearance-none "
                            style={{
                              background: `linear-gradient(to right, ${
                                Theme.colors.primary
                              } ${(creativity / 10) * 100}%, white ${
                                (creativity / 10) * 100
                              }%)`,
                              color: Theme.colors.primary,
                            }}
                          />

                          {/* Indicator Bar with Tooltips */}
                          <div
                            className="flex justify-between text-xs font-medium mt-2"
                            style={{ color: Theme.colors.text.weak }}
                          >
                            <div className="relative group">
                              <span
                                className={
                                  creativity === 0
                                    ? "font-bold text-center"
                                    : "text-center"
                                }
                                style={{
                                  color:
                                    creativity === 0
                                      ? Theme.colors.primary
                                      : undefined,
                                }}
                              >
                                Most Structured
                              </span>
                              <div
                                className="hidden lg:absolute lg:top-full lg:left-1/2 lg:transform lg:-translate-x-1/2 lg:mt-2 w-max text-xs rounded px-3 py-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 shadow-lg"
                                style={{
                                  backgroundColor: Theme.colors.grounding,
                                  color: Theme.colors.background,
                                }}
                              >
                                Highly precise and factual text with minimal
                                variation.
                              </div>
                            </div>

                            <div className="relative group">
                              <span
                                className={
                                  creativity >= 4.5 && creativity <= 5.5
                                    ? "font-bold text-center"
                                    : "text-center"
                                }
                                style={{
                                  color:
                                    creativity >= 4.5 && creativity <= 5.5
                                      ? Theme.colors.primary
                                      : undefined,
                                }}
                              >
                                Balanced
                              </span>
                              <div
                                className="hidden lg:absolute lg:top-full lg:left-1/2 lg:transform lg:-translate-x-1/2 lg:mt-2 w-max text-xs rounded px-3 py-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 shadow-lg"
                                style={{
                                  backgroundColor: Theme.colors.grounding,
                                  color: Theme.colors.background,
                                }}
                              >
                                A mix of structured content with slight
                                variations for engagement.
                              </div>
                            </div>

                            <div className="relative group">
                              <span
                                className={
                                  creativity === 10
                                    ? "font-bold text-center ml-2 xs:ml-0"
                                    : "text-center"
                                }
                                style={{
                                  color:
                                    creativity === 10
                                      ? Theme.colors.primary
                                      : undefined,
                                }}
                              >
                                Most Creative
                              </span>
                              <div
                                className="hidden lg:absolute lg:top-full lg:left-1/2 lg:transform lg:-translate-x-1/2 lg:mt-2 w-max text-xs rounded px-3 py-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 shadow-lg"
                                style={{
                                  backgroundColor: Theme.colors.grounding,
                                  color: Theme.colors.background,
                                }}
                              >
                                Free-flowing, expressive text with maximum
                                variation.
                              </div>
                            </div>
                          </div>
                        </div>

                         <div className="space-y-2 mt-6">
                                                  <label
                                                    className="flex items-center gap-2 text-sm font-medium"
                                                    style={{ color: Theme.colors.text.weak }}
                                                  >
                                                    Technical Depth
                                                    <div className="relative group">
                                                      <FaInfoCircle
                                                        className="cursor-pointer"
                                                        style={{ color: Theme.colors.text.weak }}
                                                      />
                                                      <div className="hidden group-hover:block absolute z-10 left-full ml-2 -translate-y-1/2 w-64 p-2 text-xs rounded-lg shadow-lg bg-gray-800 text-white">
                                                        Choose how technical the content should be in
                                                        your presentation.
                                                      </div>
                                                    </div>
                                                  </label>
                                                  <select
                                                    value={technicalDepth}
                                                    onChange={(e) => dispatch(setTechnicalDepth(e.target.value))}
                                                    className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2"
                                                    style={{
                                                      backgroundColor: Theme.colors.background,
                                                      color: Theme.colors.text.strong,
                                                      borderColor: Theme.colors.stroke.weak,
                                                      outlineColor: Theme.colors.primary,
                                                    }}
                                                  >
                                                    <option value="Auto">Auto</option>
                                                    <option value="Basic">Basic</option>
                                                    <option value="Medium">Medium</option>
                                                    <option value="Advanced">Advanced</option>
                                                    <option value="Expert">Expert</option>
                                                  </select>
                                                </div>
                      </div>
                    </div>

                    <div className="flex w-full justify-center mt-4 xl:mt-12">
                      <button
                        disabled={
                          isLoading || (websiteUrl.length > 0 && !isValidLink)
                        }
                        onClick={()=>{
                          setIsOutlineReviewed(true);
                          setActiveTab("outline");
                          getWebsiteData();
                        }}
                        className={`lg:w-1/2 w-[80%] py-2 rounded-lg font-semibold active:scale-95 transition transform duration-300  ${
                          isLoading || (websiteUrl.length > 0 && !isValidLink)
                            ? "cursor-not-allowed"
                            : "hover:opacity-90"
                        }`}
                        style={{
                          backgroundColor:
                            isLoading || (websiteUrl.length > 0 && !isValidLink)
                              ? Theme.colors.stroke.weak
                              : Theme.colors.primary,
                          color:
                            isLoading || (websiteUrl.length > 0 && !isValidLink)
                              ? Theme.colors.text.weak
                              : "#FFFFFF",
                        }}
                      >
                        Review Outline
                      </button>
                    </div>
                  </div>
                </>
              )
              
              :
              (
                <div className="space-y-4  pr-2 max-h-full relative">
                  {isOutlineLoading ? (
                    <div className="flex flex-col justify-center items-center py-5 relative">
                      <ul className="space-y-6 w-full">
                        {Array.from({ length: 5 }).map((_, idx) => (
                          <li key={idx} className="relative w-full">
                            <div className="border w-full border-gray-200 p-4 rounded-md shadow-sm bg-white flex flex-col gap-2 animate-pulse">
                              <div className="h-5 bg-gray-200 rounded w-2/3"></div>
                              <div className="h-4 bg-gray-100 rounded w-1/3"></div>
                            </div>
                          </li>
                        ))}
                      </ul>
                      {/* <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                  <p className="text-base">Outline Generating</p> */}
                   <div className="absolute   bottom-0 left-0 w-full bg-white border-t border-gray-200 py-3 flex justify-center">
                        <button
                          disabled={
                            isLoading || (websiteUrl.length > 0 && !isValidLink) || isOutlineLoading
                          }
                          onClick={() => {
                             
                            dispatch(resetToAuto());
                            handleButtonClick();
                          }}
                          className={`lg:w-1/2 w-[80%] py-2 rounded-lg font-semibold active:scale-95 transition transform duration-300 ${
                            isLoading || (websiteUrl.length > 0 && !isValidLink) || isOutlineLoading
                              ? "cursor-not-allowed"
                              : "hover:opacity-90"
                          }`}
                          style={{
                            backgroundColor:
                              isLoading ||
                              (websiteUrl.length > 0 && !isValidLink) || isOutlineLoading
                                ? Theme.colors.stroke.weak
                                : Theme.colors.primary,
                            color:
                              isLoading ||
                              (websiteUrl.length > 0 && !isValidLink) || isOutlineLoading
                                ? Theme.colors.text.weak
                                : "#FFFFFF",
                          }}
                        >
                          Generate Presentation
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="flex flex-col max-h-[70vh]">
                      <div className="flex-1 overflow-y-auto pr-1">
                        <ul className="space-y-6">
                          {outline?.map((slide: any, idx: number) => (
                            <React.Fragment key={slide.outlineID}>
                              <li className="relative group">
                                <div className="relative border border-gray-200 p-4 rounded-md shadow-sm bg-white flex flex-col gap-2 transition-all duration-200 hover:shadow-md hover:border-gray-300">
                                  {editingIndex !== idx && (
                                    <div className="absolute top-2 right-2 flex space-x-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                                      <button
                                        onClick={() => {
                                          setEditingIndex(idx);
                                          setEditedOutline({
                                            title: slide.title,
                                            keywords: slide.keywords || "",
                                            slideInput: slide.slideInput || "",
                                          });
                                        }}
                                        title="Edit"
                                        className="transition-all duration-200 hover:scale-110"
                                      >
                                        <FaEdit
                                          className="text-gray-500 hover:text-blue-600 transition-colors duration-200"
                                          style={{ fontSize: "1rem" }}
                                        />
                                      </button>
                                      <button
                                        onClick={() => handleDeleteOutline(idx)}
                                        title="Delete"
                                        className="transition-all duration-200 hover:scale-110"
                                      >
                                        <FaTrash
                                          className="text-gray-500 hover:text-red-500 transition-colors duration-200"
                                          style={{ fontSize: "1rem" }}
                                        />
                                      </button>
                                    </div>
                                  )}

                                  {editingIndex === idx ? (
                                    <div className="flex flex-col gap-3">
                                      <input
                                        value={editedOutline.title}
                                        onChange={(e) =>
                                          setEditedOutline({
                                            ...editedOutline,
                                            title: e.target.value,
                                          })
                                        }
                                        placeholder="Title"
                                        className="p-2 border border-gray-300 rounded-md transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
                                      />
                                      <input
                                        value={editedOutline.keywords}
                                        onChange={(e) =>
                                          setEditedOutline({
                                            ...editedOutline,
                                            keywords: e.target.value,
                                          })
                                        }
                                        placeholder="Keywords"
                                        className="p-2 border border-gray-300 rounded-md transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
                                      />
                                      <input
                                        value={editedOutline.slideInput}
                                        onChange={(e) =>
                                          setEditedOutline({
                                            ...editedOutline,
                                            slideInput: e.target.value,
                                          })
                                        }
                                        placeholder="SlideInput"
                                        className="p-2 border border-gray-300 rounded-md transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
                                      />
                                      <div className="flex gap-3">
                                        <button
                                          className="text-white bg-blue-600 px-4 py-2 rounded-md hover:bg-blue-700 transition-all duration-200"
                                          onClick={async () => {
                                            if (
                                              editedOutline.title ===
                                                slide.title &&
                                              editedOutline.keywords ===
                                                (slide.keywords || "") &&
                                              editedOutline.slideInput ===
                                                (slide.slideInput || "")
                                            ) {
                                              setEditingIndex(null);
                                              return;
                                            }

                                            const updated = [...outline];
                                            updated[idx] = {
                                              ...slide,
                                              title: editedOutline.title,
                                              keywords: editedOutline.keywords,
                                              slideInput: editedOutline.slideInput,
                                            };
                                            setOutline(updated);
                                            setEditingIndex(null);

                                            try {
                                              await axios.post(
                                                `${process.env.REACT_APP_BACKEND_URL}/api/v1/outline/blocklist/update`,
                                                {
                                                  documentId:
                                                    generatedDocumentIDoutline,
                                                  blockItem: {
                                                    outlineID: slide.outlineID,
                                                    title: editedOutline.title,
                                                    keywords: editedOutline.keywords,
                                                    slideInput: editedOutline.slideInput,
                                                  },
                                                },
                                                {
                                                  headers: {
                                                    Authorization: `Bearer ${authToken}`,
                                                  },
                                                }
                                              );
                                            } catch (error) {
                                              console.error(
                                                "Update failed",
                                                error
                                              );
                                            }
                                          }}
                                        >
                                          Save
                                        </button>
                                        <button
                                          className="text-gray-700 border border-gray-300 px-4 py-2 rounded-md hover:bg-gray-100 transition-all duration-200"
                                          onClick={() => setEditingIndex(null)}
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                    </div>
                                  ) : (
                                    <>
                                      <h3 className="text-lg font-semibold text-gray-800">
                                        {slide.title}
                                      </h3>
                                      {slide.keywords && (
                                        <p className="text-sm text-gray-600">
                                          <span className="font-medium">
                                            Keywords:
                                          </span>{" "}
                                          {slide.keywords}
                                        </p>
                                      )}
                                      {slide.slideInput && (
                                        <p className="text-sm text-gray-600">
                                          <span className="font-medium">
                                            SlideInput:
                                          </span>{" "}
                                          {slide.slideInput}
                                        </p>
                                      )}
                                    </>
                                  )}
                                </div>

                                {idx > -1 && (
                                  <div className="mt-4 flex items-center justify-center space-x-4 relative hidden group-hover:flex">
                                    <div className="flex-grow h-px bg-gray-300"></div>

                                    <div className="relative">
                                      <button
                                        className="w-8 h-8 flex items-center justify-center rounded-full border border-gray-400 bg-white text-gray-500 hover:bg-gray-100 hover:border-gray-500 transition-all duration-200 hover:scale-110"
                                        onClick={() => setInputIndex(idx)}
                                        title="Add new section"
                                      >
                                        +
                                      </button>
                                    </div>

                                    <div className="flex-grow h-px bg-gray-300"></div>
                                  </div>
                                )}
                              </li>

                              {inputIndex === idx && (
                                <div className="border border-gray-200 p-4 rounded-md shadow-sm bg-white flex flex-col gap-3 -mt-2">
                                  <input
                                    type="text"
                                    value={newOutline}
                                    onChange={(e) =>
                                      setNewOutline(e.target.value)
                                    }
                                    placeholder="Title"
                                    className="p-2 border border-gray-300 rounded-md transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
                                    autoFocus
                                  />

                                  <div className="flex gap-3">
                                    <button
                                      className="text-white bg-blue-600 px-4 py-2 rounded-md hover:bg-blue-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                                      onClick={() => handleAddOutline(idx)}
                                      disabled={!newOutline.trim()}
                                    >
                                      {newOutlineLoading ? (
                                        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                      ) : (
                                        "Add"
                                      )}
                                    </button>
                                    <button
                                      className="text-gray-700 border border-gray-300 px-4 py-2 rounded-md hover:bg-gray-100 transition-all duration-200"
                                      onClick={() => {
                                        setInputIndex(null);
                                        setNewOutline("");
                                      }}
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                </div>
                              )}
                            </React.Fragment>
                          ))}
                        </ul>
                      </div>
                      <div className="flex w-full justify-center mt-4">
                        <button
                          disabled={
                            isLoading || (websiteUrl.length > 0 && !isValidLink) || isOutlineLoading
                          }
                          onClick={() => {

                            dispatch(resetToAuto());
                            handleButtonClick();
                          }}
                          className={`lg:w-1/2 w-[80%] py-2 rounded-lg font-semibold active:scale-95 transition transform duration-300 ${
                            isLoading || (websiteUrl.length > 0 && !isValidLink) || isOutlineLoading
                              ? "cursor-not-allowed"
                              : "hover:opacity-90"
                          }`}
                          style={{
                            backgroundColor:
                              isLoading ||
                              (websiteUrl.length > 0 && !isValidLink) || isOutlineLoading
                                ? Theme.colors.stroke.weak
                                : Theme.colors.primary,
                            color:
                              isLoading ||
                              (websiteUrl.length > 0 && !isValidLink) || isOutlineLoading
                                ? Theme.colors.text.weak
                                : "#FFFFFF",
                          }}
                        >
                          Generate Presentation
                        </button>
                      </div>
                    </div>
                  )
                  }
                </div>
              ) 
              }
            </div>
          </div>
        </div>
      )}
      {/* Color Selection Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-[40]">
  <div
    className="p-6 rounded-2xl shadow-lg w-[90%] max-w-md relative"
    style={{ backgroundColor: Theme.colors.background }}
  >
    <h2
      className="text-xl font-bold mb-4 text-center"
      style={{ color: Theme.colors.text.strong }}
    >
      Select Branding Colors
    </h2>

    <div className="space-y-4">
      {/* Primary Color */}
      <div className="grid grid-cols-3 items-center gap-2">
        <label
          className="font-semibold"
          style={{ color: Theme.colors.text.weak }}
        >
          Primary Color:
        </label>
        <input
          type="text"
          value={primaryColor}
          onChange={(e) => setPrimaryColor(e.target.value)}
          className="w-24 p-2 border rounded-lg text-center shadow-sm focus:ring-2 outline-none"
          style={{
            borderColor: Theme.colors.stroke.weak,
            color: Theme.colors.text.strong,
            fontFamily: Theme.font.family,
            backgroundColor: Theme.colors.background,
            boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
          }}
        />
        <div className="relative w-12 h-12">
          <input
            type="color"
            value={primaryColor}
            onChange={(e) => setPrimaryColor(e.target.value)}
            className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
          />
          <div
            className="w-12 h-12 rounded-full border shadow-md cursor-pointer transition-transform hover:scale-110"
            style={{
              backgroundColor: primaryColor,
              borderColor: Theme.colors.stroke.weak,
            }}
          />
        </div>
      </div>

      {/* Secondary Color */}
      <div className="grid grid-cols-3 items-center gap-2">
        <label
          className="font-semibold"
          style={{ color: Theme.colors.text.weak }}
        >
          Secondary Color:
        </label>
        <input
          type="text"
          value={secondaryColor}
          onChange={(e) => setSecondaryColor(e.target.value)}
          className="w-24 p-2 border rounded-lg text-center shadow-sm focus:ring-2 outline-none"
          style={{
            borderColor: Theme.colors.stroke.weak,
            color: Theme.colors.text.strong,
            fontFamily: Theme.font.family,
            backgroundColor: Theme.colors.background,
            boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
          }}
        />
        <div className="relative w-12 h-12">
          <input
            type="color"
            value={secondaryColor}
            onChange={(e) => setSecondaryColor(e.target.value)}
            className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
          />
          <div
            className="w-12 h-12 rounded-full border shadow-md cursor-pointer transition-transform hover:scale-110"
            style={{
              backgroundColor: secondaryColor,
              borderColor: Theme.colors.stroke.weak,
            }}
          />
        </div>
      </div>
    </div>

    {/* Modal Buttons */}
    <div className="mt-6 flex justify-end space-x-4">
      <button
        className="px-4 py-2 rounded-lg transition-all"
        style={{
          backgroundColor: Theme.colors.stroke.weak,
          color: Theme.colors.text.weak,
        }}
        onClick={() => setIsModalOpen(false)}
      >
        Cancel
      </button>
      <button
        className="px-4 py-2 rounded-lg transition-all shadow-md"
        style={{
          backgroundColor: Theme.colors.primary,
          color: "#FFFFFF",
        }}
        onClick={() => {
          handleSaveColors();
          setIsModalOpen(false);
        }}
      >
        Save
      </button>
    </div>
  </div>
</div>

      )}
      <GuidedTour />
      <GuidedTourMobile />
    </div>
  );
};

export default SelectPresentationType;
